import React from 'react';
import image3D from '../assets/2year.png'; // ✅ Check image path

const TwoYearProgram = () => {
  return (
    <div
      style={{
        padding: '40px',
        fontFamily: 'sans-serif',
        background: 'white',
        minHeight: '100vh',
      }}
    >
      {/* Heading + Image Row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {/* Left Section: Heading + Subheading + Small Container */}
        <div style={{ flex: '1', minWidth: '280px', marginLeft: '70px' }}>
          <h1 style={{ marginBottom: '10px', color: '#111', fontSize: '40px' }}>
          2-Year Expertise Program
          </h1>
          <p style={{ fontSize: '22px', color: '#111', marginBottom: '20px' }}>
          Deep Expertise & Advanced Projects
          </p>

          {/* Program Overview Container */}
          <div
            style={{
              padding: '25px',
              background: '#F9CF00',
              borderRadius: '12px',
              boxShadow: '0 6px 30px rgba(8, 127, 255, 0.15)',
              maxWidth: '340px',
              marginTop: '10px',
              transition: 'all 0.4s ease',
              cursor: 'pointer',
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, 123, 255, 0.35)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = '0 6px 30px rgba(0, 123, 255, 0.15)';
            }}
          >
            <h2 style={{ marginBottom: '10px', color: '#111', fontSize: '20px' }}>
              Program Overview
            </h2>
            <p style={{ color: '#111', fontSize: '15px' }}>
            A comprehensive 2-year training program designed to provide deep expertise in multiple advanced technologies and offer hands-on real-world experience. Become an expert in Cloud, Microservices, AI, and Full-Stack Development, plus extended internship opportunities.</p>
          </div>
        </div>

        {/* Right Section: Image */}
        <div style={{ flex: '0 0 500px', textAlign: 'center', marginLeft: '-10px' }}>
          <img
            src={image3D}
            alt="3D Professor"
            style={{
              width: '100%',
              maxWidth: '400px',
              height: '500px',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>

      {/* Monthly Training Breakdown Heading */}
      <h2
        style={{
          marginTop: '50px',
          textAlign: 'center',
          color: '#111',
          fontSize: '26px',
        }}
      >
        Monthly Training Breakdown
      </h2>

      {/* Container for Monthly Breakdown */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          flexWrap: 'wrap',
          marginTop: '30px',
        }}
      >
        {/* First Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0, 123, 255, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 123, 255, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 123, 255, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Year 1</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Same as 1-Year Program</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Months 1-3: Foundation Phase</li>
            <li>Months 4-6: Specialization Phase</li>
            <li>Months 7-9: Real-Life Projects Phase</li>
            <li>Months 10-12: Internship & Job Preparation</li>
          </ul>
        </div>

        {/* Second Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 105, 180, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 105, 180, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 105, 180, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Months 13-18: Advanced Specialization</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Master in-demand advanced technologies to boost your career</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Cloud Technologies: AWS, Azure, Google Cloud Platform</li>
            <li>Artificial Intelligence: ML, NLP, TensorFlow, PyTorch</li>
            <li>Full-Stack Development: Advanced JavaScript (Node.js, Express), Angular/React, Database Management (MongoDB, PostgreSQL)</li>
            <li>Capstone Project: Integrating AI, Cloud, and Microservices</li>
          </ul>
        </div>

        {/* Third Container */}
        <div
          style={{
            flex: '1',
            maxWidth: '300px',
            height: '350px', // Same height for all containers
            padding: '20px',
            background: '#D9D9D9',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(255, 193, 7, 0.15)',
            transition: 'all 0.3s ease',
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 193, 7, 0.25)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 193, 7, 0.15)';
          }}
        >
          <h3 style={{ marginBottom: '10px', color: '#111', fontSize: '18px' }}>Months 19-24: Extended Internship with Real-World Projects</h3>
          <h4 style={{ fontSize: '16px', color: '#333' }}>Real-world industry projects to polish skills before the job</h4>
          <ul style={{ color: '#111', fontSize: '14px' }}>
            <li>Extended Internship with Client-Based Use Cases</li>
            <li>End-to-End Project Development</li>
            <li>Project Documentation & Hosting</li>
            <li>Soft Skills & Communication Enhancement</li>
            <li>Final Mock Interviews (Technical + HR)</li>
          </ul>
        </div>
      </div>

      {/* Heading for the 6 Sections */}
<h2 style={{ textAlign: 'center', fontSize: '26px', color: '#222', marginTop: '60px' }}>
  Other Details
</h2>

            {/* 6 Sections Below - Key Features or Additional Modules */}
            <div
  style={{
    marginTop: '60px',
    maxWidth: '1000px',
    margin: 'auto',
    backgroundColor: '#fff',
    padding: '30px',
    fontFamily: 'sans-serif',
  }}
>
  {[
    [
      {
        title: '💰 Program Fee',
        desc: [
          'Total Cost: ₹8,000/- only (one-time)',
          'Total Cost: ₹10,000/- only (Two-time)',
          'Total Cost: ₹11,000/- only (Three-time)',
          'Note: This is a non-refundable, affordable program designed to provide maximum value.',
        ],
      },
      {
        title: '✅ Eligibility Criteria',
        desc: [
          'A College Student (Diploma / UG / PG)',
          'A Pass-Out / Fresher Looking for Jobs',
          'Willing to Learn and Work Practically',
          'Has a Laptop and Internet Connection',
          'Can Dedicate at least 3 Hour Daily',
        ],
      },
    ],
    [
      {
        title: '📜 Rules & Guidelines',
        desc: [
          'Complete weekly tasks to stay active.',
          'Irregular or inactive participants may be removed.',
          'Respect all mentors and fellow learners.',
          'Group projects will require team collaboration.',
          'Internship Certificates will be given only after project submission.',
        ],
      },
      {
        title: '🎁 What You Get',
        desc: [
          '2-Year Guided Training',
          'Access to Resources & Assignments',
          'Internship & Project Certificates',
          'Mentor Support & Job Assistance',
          'Professional Profile Building',
          'Advanced Technologies Exposure',
        ],
      },
    ],
    [
      {
        title: '📌 Why Choose This Program?',
        desc: [
          'Affordable one-time fee',
          'Real mentorship and career guidance',
          'Hands-on experience, not just theory',
          'Built for freshers, students & career switchers',
          'Extended internship & deep exposure to new-age technologies',
        ],
      },
      {
        title: '📞 Get in Touch',
        desc: [
          '📧 Email: admin@willovate.in',
          '📱 WhatsApp: +91-8237883928',
        ],
      },
    ],
  ].map((row, rowIndex) => (
    <div key={rowIndex} style={{ marginBottom: '30px' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: '40px',
          position: 'relative',
        }}
      >
        {row.map((item, i) => (
          <div key={i} style={{ flex: '1', padding: '10px', textAlign: 'center' }}>
            <h3 style={{ fontSize: '22px', color: '#111', marginBottom: '12px' }}>{item.title}</h3>
            <ul style={{ listStyleType: 'disc', marginLeft: '20px', color: '#444', padding: '0', textAlign: 'left' }}>
              {item.desc.map((point, index) => (
                <li key={index} style={{ marginBottom: '8px', fontSize: '16px' }}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
        {/* Vertical Line Between Boxes */}
        <div style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '50%',
          width: '1px',
          backgroundColor: '#ccc',
          transform: 'translateX(-50%)',
        }} />
      </div>
      {/* Horizontal line below each row */}
      {rowIndex < 2 && (
        <hr
          style={{
            marginTop: '30px',
            border: 'none',
            borderTop: '1px solid #ccc',
          }}
        />
      )}
    </div>
  ))}
</div>

      {/* Closing Note or Call to Action */}
      <div style={{ marginTop: '60px', textAlign: 'center' }}>
  <h2 style={{ fontSize: '24px', color: '#111' }}>
    Ready to kickstart your tech career?
  </h2>
  <button
  style={{
    padding: '12px 24px',
    fontSize: '16px',
    backgroundColor: '#F19F4D',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(8, 8, 8, 0.3)',
    transition: 'background-color 0.3s ease',
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = '#d9883b'; // Slightly darker on hover
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = '#F19F4D'; // Restore original color
  }}
  onClick={() => {
    window.open('https://forms.gle/VZfbRCurJkDGXdx7A', '_blank');
  }}
>
  Enroll Now
</button>
</div>

    </div>
  );
};

export default TwoYearProgram;
